import crud from "./_crud"

const actions = crud('sys_module', 'el módulo', 'los módulos')

export default actions